import React, { ReactElement, useEffect, useState } from "react";
import { SelectedIcon } from "../../Icons";
import { sanitiseString, concatStringFromClassesArrayList } from "../../Utils";
export interface Props {
  id: string;
  children: ReactElement;
  title: string;
  open?: boolean;
  saveState?: boolean;
  dataTestId?: string;
  classes?: string;
  titleTag?: string;
}

export const Details = (props: Props) => {
  const localStorageKey = `details_${props.id}`;
  const titleTag = props.titleTag || "h2";

  const [open, setOpen] = useState(() => {
    if (props.saveState) {
      const storedValue = localStorage.getItem(localStorageKey);
      if (storedValue !== null) {
        return storedValue === "true";
      } else {
        return props.open || false;
      }
    }
    return props.open || false;
  });

  const classList = {
    defaultClass: "ons-details ons-js-details ons-details--initialised",
    optionalClasses: [
      props.classes ? props.classes : null,
      open ? "ons-details--open" : "",
    ],
  };

  const className = concatStringFromClassesArrayList(classList);

  const handleToggle = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setOpen(!open);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setOpen(!open);
    }
  };

  useEffect(() => {
    if (props.saveState === true) {
      localStorage.setItem(localStorageKey, open.toString());
    }
  }, [open, localStorageKey, props.saveState]);

  return (
    <div
      id={props.id}
      className={className}
      data-testid={`details-${sanitiseString(props.dataTestId || "")}`}
      role="group"
      {...(open ? { open: true } : {})}
    >
      <div
        className="ons-details__heading ons-js-details-heading"
        data-testid={`details-heading-${sanitiseString(
          props.dataTestId || ""
        )}`}
        role="link"
        aria-controls={props.id}
        aria-expanded={open}
        tabIndex={0}
        onClick={(e) => {
          handleToggle(e);
        }}
        onKeyDown={handleKeyDown}
      >
        {React.createElement(
          titleTag,
          {
            className: "ons-details__title",
            "data-testid": `details-title-${sanitiseString(
              props.dataTestId || ""
            )}`,
          },
          props.title
        )}
        <span className="ons-details__icon">
          <SelectedIcon iconType="ArrowIcon" />
        </span>
      </div>
      {open && (
        <div
          id="details-with-save-content"
          className="ons-details__content ons-js-details-content"
          aria-hidden={!open}
          data-testid={`details-children-${sanitiseString(
            props.dataTestId || ""
          )}`}
        >
          {props.children}
        </div>
      )}
    </div>
  );
};
